var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.48753 2.37598L13.0552 5.66924C13.2379 5.83781 13.2492 6.12251 13.0807 6.30513C12.9121 6.48774 12.6274 6.49913 12.4448 6.33056L9.95 4.02769V12.4999C9.95 12.7484 9.74853 12.9499 9.5 12.9499C9.25148 12.9499 9.05 12.7484 9.05 12.4999V4.0863L6.8182 6.3181C6.64247 6.49383 6.35754 6.49383 6.18181 6.3181C6.00607 6.14236 6.00607 5.85744 6.18181 5.6817L9.48753 2.37598ZM3.5 8.0499C3.74853 8.0499 3.95 8.25137 3.95 8.4999V13.4999C3.95 14.0798 4.4201 14.5499 5 14.5499H14C14.5799 14.5499 15.05 14.0798 15.05 13.4999V8.4999C15.05 8.25137 15.2515 8.0499 15.5 8.0499C15.7485 8.0499 15.95 8.25137 15.95 8.4999V13.4999C15.95 14.5769 15.077 15.4499 14 15.4499H5C3.92305 15.4499 3.05 14.5769 3.05 13.4999V8.4999C3.05 8.25137 3.25147 8.0499 3.5 8.0499Z",
    fill: "#052D61"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadBlue);
export default __webpack_public_path__ + "static/media/upload-blue.465442e7de1a43dc8be976b34eba8ef8.svg";
export { ForwardRef as ReactComponent };